import { Component, type ErrorInfo, type ReactNode } from 'react';

/** App-wide error boundary: a crash shows a recoverable screen, not a white page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    // Hook for Sentry/telemetry.
    console.error('app error', error, info.componentStack);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="notfound">
          <div className="t-eyebrow">something broke</div>
          <h1 className="notfound__h">This screen hit an error.</h1>
          <p className="notfound__p">Your progress is safe. Reload to continue.</p>
          <button className="uc-btn uc-btn--primary uc-btn--md" onClick={() => location.reload()}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
